import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./LeftSideBar.css"; 

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faTachometerAlt, faAngleUp, faAngleDown, faThLarge, faCog, faAnglesRight, faToggleOn, faToggleOff
} from "@fortawesome/free-solid-svg-icons";

const LeftSideBar = ({ isOpen, setIsOpen }) => {
  const location = useLocation();
  const [dashboardOpen, setDashboardOpen] = useState(true); // Dashboard open by default
  const [applicationsOpen, setApplicationsOpen] = useState(false); // Pages closed by default
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1100);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1100);
  };

  window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isMobile) {
      setIsOpen(false); // Ensure sidebar is closed by default on mobile
    }
  }, [isMobile, setIsOpen]);

  const toggleDashboard = () => {
    setDashboardOpen((prev) => !prev);
    if (!dashboardOpen) setApplicationsOpen(false); // Close Pages if Dashboard is opened
  };

  const toggleApplications = () => {
    setApplicationsOpen((prev) => !prev);
    if (!applicationsOpen) setDashboardOpen(false); // Close Dashboard if Pages is opened
  };

  return (
    <div 
      className={`sidebar ${isOpen ? "expanded" : "collapsed"}`}
    >
      <div className="sidebar-header">
        <button className="toggle-btn" onClick={() => setIsOpen(!isOpen)}>
          <FontAwesomeIcon icon={isOpen ? faToggleOn : faToggleOff} className="fas" />
        </button>
      </div>

      <nav className="">
        <ul>
          <li onClick={toggleDashboard} className={`${dashboardOpen ? "active" : "border-bottom"} ${location.pathname.includes("overview") || location.pathname.includes("analytics") || location.pathname.includes("reports") ? "active" : ""}`}>
            <div className="menu-item">
              <FontAwesomeIcon icon={faTachometerAlt} className="menu-icon" />
              {(isOpen) && <span className="menu-text">Template</span>}
              {(isOpen) && (
                <FontAwesomeIcon icon={dashboardOpen ? faAngleUp : faAngleDown} className="angle-icon" />
              )}
            </div>
          </li>
          {dashboardOpen && isOpen && (
            <ul className="submenu open">
              <li className={location.pathname === "/profile" ? "active" : ""}>
                <Link className="f-14 d-block" to="/profile">
                  <FontAwesomeIcon icon={faAnglesRight} className="f-10 mr-5" /> Profile
                </Link>
              </li>
              <li className={location.pathname === "/email" ? "active" : ""}>
                <Link className="f-14 d-block" to="/email">
                  <FontAwesomeIcon icon={faAnglesRight} className="f-10 mr-5" /> Email
                </Link>
              </li>
              <li className={location.pathname === "/reports" ? "active" : ""}>
                <Link className="f-14 d-block" to="/reports">
                  <FontAwesomeIcon icon={faAnglesRight} className="f-10 mr-5" /> Reports
                </Link>
              </li>
            </ul>
          )}

          <li onClick={toggleApplications} className={`${applicationsOpen ? "active" : "border-bottom"}`}>
            <div className="menu-item">
              <FontAwesomeIcon icon={faThLarge} className="menu-icon" />
              {(isOpen) && <span className="menu-text">Pages</span>}
              {(isOpen) && (
                <FontAwesomeIcon icon={applicationsOpen ? faAngleUp : faAngleDown} className="angle-icon" />
              )}
            </div>
          </li>
          {applicationsOpen && isOpen && (
            <ul className="submenu open custom-scroll">
              <li className={location.pathname === "/button" ? "active" : ""}><Link className="f-14 d-block" to="/button">
                <FontAwesomeIcon icon={faAnglesRight} className="f-10 mr-5" /> Button</Link>
              </li>
              <li className={location.pathname === "/form" ? "active" : ""}><Link className="f-14 d-block" to="/form">
                <FontAwesomeIcon icon={faAnglesRight} className="f-10 mr-5" /> Form</Link>
              </li>
              <li className={location.pathname === "/table" ? "active" : ""}><Link className="f-14 d-block" to="/table">
                <FontAwesomeIcon icon={faAnglesRight} className="f-10 mr-5" /> Table</Link>
              </li>
              <li className={location.pathname === "/card" ? "active" : ""}><Link className="f-14 d-block" to="/card">
                <FontAwesomeIcon icon={faAnglesRight} className="f-10 mr-5" /> Card</Link>
              </li>
              <li className={location.pathname === "/badge" ? "active" : ""}><Link className="f-14 d-block" to="/badge">
                <FontAwesomeIcon icon={faAnglesRight} className="f-10 mr-5" /> Badge</Link>
              </li>
              <li className={location.pathname === "/tabs" ? "active" : ""}><Link className="f-14 d-block" to="/tabs">
                <FontAwesomeIcon icon={faAnglesRight} className="f-10 mr-5" /> Tabs</Link>
              </li>
              <li className={location.pathname === "/accordion" ? "active" : ""}><Link className="f-14 d-block" to="/accordion">
                <FontAwesomeIcon icon={faAnglesRight} className="f-10 mr-5" /> Accordian</Link>
              </li>
              <li className={location.pathname === "/modal" ? "active" : ""}><Link className="f-14 d-block" to="/modal">
                <FontAwesomeIcon icon={faAnglesRight} className="f-10 mr-5" /> Modal</Link>
              </li>
              <li className={location.pathname === "/alert" ? "active" : ""}><Link className="f-14 d-block" to="/alert">
                <FontAwesomeIcon icon={faAnglesRight} className="f-10 mr-5" /> Alert</Link>
              </li>
              <li className={location.pathname === "/progressbar" ? "active" : ""}><Link className="f-14 d-block" to="/progressbar">
                <FontAwesomeIcon icon={faAnglesRight} className="f-10 mr-5" /> Progress Bar</Link>
              </li>
              <li className={location.pathname === "/tooltip" ? "active" : ""}><Link className="f-14 d-block" to="/tooltip">
                <FontAwesomeIcon icon={faAnglesRight} className="f-10 mr-5" /> Tooltip</Link>
              </li>
              <li className={location.pathname === "/fileupload" ? "active" : ""}><Link className="f-14 d-block" to="/fileupload">
                <FontAwesomeIcon icon={faAnglesRight} className="f-10 mr-5" /> File Upload</Link>
              </li>
              <li className={location.pathname === "/dropdown" ? "active" : ""}><Link className="f-14 d-block" to="/dropdown">
                <FontAwesomeIcon icon={faAnglesRight} className="f-10 mr-5" /> Dropdown</Link>
              </li>
              <li className={location.pathname === "/wysiwygEditor" ? "active" : ""}><Link className="f-14 d-block" to="/wysiwygEditor">
                <FontAwesomeIcon icon={faAnglesRight} className="f-10 mr-5" /> Wysiwyg Editor</Link>
              </li>
              <li className={location.pathname === "/loader" ? "active" : ""}><Link className="f-14 d-block" to="/loader">
                <FontAwesomeIcon icon={faAnglesRight} className="f-10 mr-5" /> Loader</Link>
              </li>
              <li className={location.pathname === "/imageCropper" ? "active" : ""}><Link className="f-14 d-block" to="/imageCropper">
                <FontAwesomeIcon icon={faAnglesRight} className="f-10 mr-5" /> Image Cropper</Link>
              </li>
              <li className={location.pathname === "/timeline" ? "active" : ""}><Link className="f-14 d-block" to="/timeline">
                <FontAwesomeIcon icon={faAnglesRight} className="f-10 mr-5" /> Timeline</Link>
              </li>
              <li className={location.pathname === "/calendar" ? "active" : ""}><Link className="f-14 d-block" to="/calendar">
                <FontAwesomeIcon icon={faAnglesRight} className="f-10 mr-5" /> Calendar</Link>
              </li>
              <li className={location.pathname === "/countdown" ? "active" : ""}><Link className="f-14 d-block" to="/countdown">
                <FontAwesomeIcon icon={faAnglesRight} className="f-10 mr-5" /> Countdown</Link>
              </li>
              <li className={location.pathname === "/ribbon" ? "active" : ""}><Link className="f-14 d-block" to="/ribbon">
                <FontAwesomeIcon icon={faAnglesRight} className="f-10 mr-5" /> Ribbon</Link>
              </li>
              <li className={location.pathname === "/StickyElement" ? "active" : ""}><Link className="f-14 d-block" to="/StickyElement">
                <FontAwesomeIcon icon={faAnglesRight} className="f-10 mr-5" /> Sticky Elements</Link>
              </li>
              <li className={location.pathname === "/GuidedTour" ? "active" : ""}><Link className="f-14 d-block" to="/GuidedTour">
                <FontAwesomeIcon icon={faAnglesRight} className="f-10 mr-5" /> Guided Tour</Link>
              </li>
              <li className={location.pathname === "/reports" ? "active" : ""}><Link className="f-14 d-block" to="/reports">
                <FontAwesomeIcon icon={faAnglesRight} className="f-10 mr-5 mr-5" /> Reports</Link>
              </li>
            </ul>
          )}
        </ul>
      </nav>
    </div>
  );
};

export default LeftSideBar;